import React from 'react';
import classnames from 'classnames';
import { Rating } from '@material-ui/lab';
import {
  Box,
  Typography,
  Button,
  makeStyles,
  withStyles
} from '@material-ui/core';
import { textTruncate } from '../../../../utils';
import { Link } from 'react-router-dom';
import ArrowRightAlt from '@material-ui/icons/ArrowRightAlt';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import styles from './styles';
import VideoModel from '../PopupVideoPlayer/videoModel';

const useStyles = makeStyles(styles);

const StyledRating = withStyles({
  iconFilled: {
    color: '#ffba05'
  },
  iconEmpty: {
    color: '#fff'
  }
})(Rating);

function MovieBanner(props) {
  const [value, setValue] = React.useState(2);
  const { movie, fullDescription } = props;
  const classes = useStyles(props);
  if (!movie) return null;
  console.log('movieeeeeeeeeee', movie);
  console.log('description', fullDescription);
  return (
    <div className={classes.movieHero}>
      <div className={classes.infoSection}>
        <header>
          {/* <header className={classes.movieHeader}> */}

          {fullDescription ? (
            <div
              className={classes.background}
              style={{
                backgroundImage: `url(${movie.images[0].url})`
              }}></div>
          ) : (
            <div

            // className={classes.blurBackground}
            // style={{
            //   backgroundImage: `url(${movie.images[0].url})`
            // }}
            />
          )}
        </header>
        {fullDescription ? (
          <div className={classes.MovieBannerheader}>
            <Typography
              className={classes.movieTitle}
              variant="h1"
              color="inherit">
              {movie.name}
            </Typography>
            <Typography
              className={classes.descriptionText}
              variant="body1"
              color="inherit">
              {textTruncate(movie.description, 450)}
            </Typography>
            <Typography
              className={classes.director}
              variant="h4"
              color="inherit">
              By: {movie.director}
            </Typography>
            <Typography
              className={classes.duration}
              variant="body1"
              color="inherit">
              {movie.duration} min
            </Typography>
            {/* <Typography className={classes.genre} variant="body1" color="inherit">
               {movie.genre}
             </Typography> */}

            {/* {fullDescription && ( */}
            <Box mb={3} display="flex" alignItems="center" flexWrap="wrap">
              {/* {movie.genre.split(',').map((genre, index) => (
                   <Typography
                     key={`${genre}-${index}`}
                     className={classes.tag}
                     variant="body1"
                     color="inherit">
                     {genre}
                   </Typography>
                 ))} */}
              <Typography
                className={classes.tag}
                variant="body1"
                color="inherit">
                {movie.genres[0].name}
              </Typography>
            </Box>
            <Box>
              <Rating name="read-only" value={value} readOnly />
            </Box>

            {/* )} */}
          </div>
        ) : (
          <div className={classes.movieHeader}>
            <Typography
              className={classes.movieTitle}
              variant="h1"
              color="inherit">
              {movie.name}
            </Typography>
            {/* <Typography
            className={classes.descriptionText}
            variant="body1"
            color="inherit">
            {textTruncate(movie.description, 450)}
          </Typography>
          <Typography className={classes.director} variant="h4" color="inherit">
            By: {movie.director}
          </Typography>
          <Typography
            className={classes.duration}
            variant="body1"
            color="inherit">
            {movie.duration} min
          </Typography>
          <Typography className={classes.genre} variant="body1" color="inherit">
            {movie.genre}
            </Typography> */}
          </div>
        )}
      </div>
      {fullDescription ? (
        <div
          className={classes.mobileblurBackground}
          style={{
            opacity: '10%',
            backgroundImage: `url(${movie.images[0].url})`
          }}
        />
      ) : (
        <div
          className={classes.blurBackground}
          style={{
            backgroundImage: `url(${movie.images[0].url})`
          }}
        />
      )}

      <div className={classes.movieActions}>
        {fullDescription ? (
          <Link
            to={`booking/${movie.slug}/${movie.id}`}
            style={{ textDecoration: 'none' }}>
            <Button variant="contained" className={classes.buyTicketbutton}>
              BOOK NOW
              <ArrowRightAlt className={classes.buttonIcon} />
            </Button>
          </Link>
        ) : (
          <Link to={`movie/${movie.slug}`} style={{ textDecoration: 'none' }}>
            <Button className={classnames(classes.button)}>
              Book Now
              <ArrowRightAlt className={classes.buttonIcon} />
            </Button>
          </Link>
        )}
      </div>
      {fullDescription ? (
        <VideoModel className={classes.player} trailerId={movie.ytTrailerID} />
      ) : (
        <a></a>
      )}
    </div>
  );
}

export default MovieBanner;
